// BajasPorOperadorPage.jsx
import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import GeneralContext from "../GeneralContext/GeneralContext";

import GenericList from "./GenericList";

export default function BajasPorOperador() {
  const { setPageTitle } = useContext(GeneralContext);
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPageTitle("Bajas por operador");
    void axios.getAdminHealth?.().catch(() => {});
    void fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const resp = await axios.getBajasPorOperador();
      setData(resp?.data || []);
    } catch (e) {
      console.error("Error cargando bajas por operador:", e);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageBody>
      <GenericList
        data={data}
        loading={loading}
        dateField="fecha_baja"
        pageTitleOverride="Bajas por operador"
        totalField="total_bajas"
        totalColumnLabel="Total bajas"
        badgeChipLabel="Bajas"
      />
    </PageBody>
  );
}
